/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import showModal from '@/util/showModal';
import HelpModalView from '@/views/HelpModalView';
import GetUserGuide from '@/services/GetUserGuide';
import showErrorMessage from '@/util/showErrorMessage';
import Config from '@config/Config';

import './ExternalHeaderView.css';
import tmplExternalHeaderView from './ExternalHeaderView.hbs';

const ExternalHeaderView = View.extend({
  template: tmplExternalHeaderView,

  className: 'external-header-view',

  events: {
    'click .bi-question-circle': 'showHelpModal'
  },

  templateContext() {
    return {
      bannerText: Config.getBannerText()
    };
  },

  async showHelpModal(e) {
    e.preventDefault();
    let userGuide;

    try {
      userGuide = await GetUserGuide();
      this.model.set('userGuide', userGuide);
    } catch (err) {
      this.showGetUserGuideError();
    } finally {
      showModal({
        title: 'Need Help?',
        view: new HelpModalView({
          model: this.model
        })
      });
    }
  },

  showGetUserGuideError() {
    showErrorMessage({
      errorCode: 'documentError',
      errorTitle: 'Document Error',
      errorMessage:
        'An error occurred while getting the User Guide. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default ExternalHeaderView;
